// src/redux/store.js

import { configureStore } from '@reduxjs/toolkit';

// 🔹 Import all your reducers
import AuthReducer from './slices/authSlice';
import CompanyReducer from './slices/ManageCompanySlice';
import CommissionReducer from './slices/CommissionSlice';
import ProfileReducer from './slices/profileSlice';
import BranchReducer from './slices/branchSlice';
import HolidayReducer from './slices/holidaySlice';
import RoleReducer from './slices/roleSlice';
import BankAccountReducer from './slices/bankAccountSlice';
import DocumentReducer from './slices/documentSlice';
import SkipEmiReducer from './slices/skipEmiSlice';
import ServiceReducer from './slices/serviceSlice';
import TeamReducer from './slices/teamSlice';
import LegalDocsReducer from './slices/legalDocsSlice';
import LoanSchemeReducer from './slices/loanSchemeSlice';
import PermissionReducer from './slices/permissionSlice';
import employeeReducer from './slices/employeeSlice';
import employeeReportReducer from './slices/employeeReportSlice';
import customerReportReducer from './slices/customerReportSlice';
import customerReducer from './slices/CreateCustomerSlice'
import employeeKycReducer from './slices/employeeKycSlice';
import customerKycReducer from './slices/customerKycSlice';
import loanReportReducer from './slices/loanReportSlice';
import loanKycApprovalReducer from './slices/LoanKycApprovalSlice';
import updateLoanReducer from './slices/updateLoanSlice';
import capitalReducer from './slices/capitalSlice'; // ✅ NEW: Capital slice
import loanEmiReducer from "./slices/LoanEmiSlice";
import loanDisbursementReducer from "./slices/loanDisbursementSlice";
import employeeLetterReducer from "./slices/EmployeeLetterSlice";
import feeAssignReducer from "./slices/feeAssignSlice";
import serviceTypeReducer from "./slices/service_type";
import serviceLoanReducer from "./slices/serviceSliceloan";
import goldLoanEmiReducer from './slices/goldLoanEmiSlice'




// 🔧 Configure store
const store = configureStore({
  reducer: {
    auth: AuthReducer,
    company: CompanyReducer,
    commission: CommissionReducer,
    profile: ProfileReducer,
    branch: BranchReducer,
    holiday: HolidayReducer,
    roles: RoleReducer,
    bankAccount: BankAccountReducer,
    documents: DocumentReducer,
    skipEmi: SkipEmiReducer,
    services: ServiceReducer,
    team: TeamReducer,
    legalDocs: LegalDocsReducer,
    loanScheme: LoanSchemeReducer,
    permissions: PermissionReducer,
    employee: employeeReducer,
    employeeReport: employeeReportReducer,
    customers: customerReportReducer,
    employeeKyc: employeeKycReducer,
    customer:customerReducer,
    customerKyc: customerKycReducer,
    loanReport: loanReportReducer,
    loanKycApproval: loanKycApprovalReducer,
    updateLoan: updateLoanReducer,
    capital: capitalReducer, // ✅ Registered capital slice here
    loanDisbursement: loanDisbursementReducer, // ✅ added
    loanEmi: loanEmiReducer,
    employeeLetter: employeeLetterReducer,
    feeAssign: feeAssignReducer, // fee assign reducer
    serviceType: serviceTypeReducer,
    serviceloan: serviceLoanReducer,
    goldLoanEmi:goldLoanEmiReducer,

    
    
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
  devTools: process.env.NODE_ENV !== 'production',
});

export default store;
